import { createContext, useContext, useEffect, useState } from "react";
import { HISTORY_ACTION_TYPE, THistoryActionType } from "../types/navigation-types";
import EventAggregator from "../events/event-aggregator";
import { EVENT } from "../events/event";

type TGlobalContextValue = {
  isNavigatingBack: boolean;
};

export const GlobalContext = createContext<TGlobalContextValue>({ isNavigatingBack: false });

export const GlobalContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isNavigatingBack, setIsNavigatingBack] = useState<boolean>(false);

  const onHistoryActionChange = (latestHistoryAction: THistoryActionType) => {
    setIsNavigatingBack(latestHistoryAction === HISTORY_ACTION_TYPE.POP);
  };

  useEffect(() => {
    const subscription = EventAggregator.subscribe(EVENT.HISTORY_ACTION, onHistoryActionChange);
    return () => {
      subscription.remove();
    };
  }, []);

  return <GlobalContext.Provider value={{ isNavigatingBack: isNavigatingBack }}>{children}</GlobalContext.Provider>;
};

export const useIsNavigatingBack = () => {
  const { isNavigatingBack } = useContext(GlobalContext);
  return isNavigatingBack;
};
